import React, { useState } from "react";
import InfoPopup from "./InfoPopup";

const Footer: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  return (
    <footer className="container mx-auto px-4 sm:px-6 lg:px-8 bg-[#000000] py-4 flex flex-col sm:flex-row justify-between items-center">
      <div className="text-white text-center sm:text-left mb-4 sm:mb-0">
        <p>For all that's underground.</p>
      </div>
      <div className="flex justify-center sm:justify-end">
        <button
          onClick={openPopup}
          className="bg-transparent text-white hover:underline"
          aria-label="Show information about Shubin Project"
        >
          Info
        </button>
      </div>
      <InfoPopup isOpen={isPopupOpen} onRequestClose={closePopup} />
    </footer>
  );
};

export default Footer;
